import {
  decompressURLSearchParams,
  getDateTimeRangeFromTimestamp,
} from '@modules/common/utils';
import { populatePayloadFromSearchParams } from '@modules/common/utils/populatePayloadFromSearchParams';
import { SearchActionType } from '@modules/feed/store/searchActionType';
import { useSearchStore } from '@modules/feed/store/searchStore';
import { getSearchWhereClauseFromBaseCondition } from '@modules/feed/utils';
import { GetUseInSearchLinkOptions } from '@modules/feed/utils/getUseInSearchLink';
import { parseStringifiedDuration } from '@modules/feed/utils/parseStringifiedDuration';
import { useEffect } from 'react';
import { combineWhereClauses } from 'v2/core/services/queryBuilder/combineWhereClauses';
import { OperationType } from 'v2/core/services/queryBuilder/whereClause';

export const useInitSearchStoreFromSearchParams = () => {
  const dispatch = useSearchStore(({ dispatch }) => dispatch);

  useEffect(() => {
    const queryPayload: Partial<GetUseInSearchLinkOptions> = {};
    populatePayloadFromSearchParams(
      queryPayload,
      ['base', 'duration', 'where', 'from', 'to'],
      decompressURLSearchParams,
    );

    if (queryPayload.duration) {
      queryPayload.duration = parseStringifiedDuration(queryPayload.duration);
      dispatch({
        type: SearchActionType.SET_QUERY,
        payload: { duration: queryPayload.duration },
      });
    }

    if (queryPayload.from && queryPayload.to) {
      queryPayload.duration = getDateTimeRangeFromTimestamp(
        parseInt(queryPayload.from, 10),
        parseInt(queryPayload.to, 10),
      );

      dispatch({
        type: SearchActionType.SET_QUERY,
        payload: {
          duration: queryPayload.duration,
        },
      });
    }

    if (queryPayload.base && queryPayload.where) {
      dispatch({
        type: SearchActionType.SET_QUERY,
        payload: {
          baseCondition: null,
          whereClause: combineWhereClauses(
            getSearchWhereClauseFromBaseCondition(queryPayload.base),
            queryPayload.where,
            OperationType.AND,
          ),
        },
      });
      return;
    }

    if (queryPayload.base) {
      dispatch({
        type: SearchActionType.SET_QUERY,
        payload: {
          baseCondition: null,
          whereClause: getSearchWhereClauseFromBaseCondition(queryPayload.base),
        },
      });
    }

    if (queryPayload.where) {
      dispatch({
        type: SearchActionType.SET_QUERY,
        payload: {
          baseCondition: null,
          whereClause: queryPayload.where,
        },
      });
    }
  }, [dispatch]);
};
